import { render } from "./InventoryMenu.vue?vue&type=template&id=2f802662&scoped=true&ts=true"
import script from "./InventoryMenu.vue?vue&type=script&lang=ts"
export * from "./InventoryMenu.vue?vue&type=script&lang=ts"

import "./InventoryMenu.vue?vue&type=style&index=0&id=2f802662&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f802662"]])

export default __exports__